// ============================================================================
// shopifyLink.js (Oct 28, 2026): carries a just-installed Shopify store across
// the PrepWorx sign-in.
//
// After a client installs the PrepWorx Fulfillment app, Shopify sends them to
//   /settings/integrations?shopify_link=<code>&shopify_shop=<store>.myshopify.com
// If they aren't signed in, the router sends them to Login and the query is lost.
// So the router saves it here first, and after sign-in brings them back to
// Settings → Integrations once, where the "Link your Shopify store" box uses it.
// The code is good for 10 minutes on the server; kept the same here.
// ============================================================================
const KEY = 'pw_shopify_link'
const MAX_AGE = 10 * 60 * 1000

function read() {
  try {
    const v = JSON.parse(localStorage.getItem(KEY) || 'null')
    if (!v || !v.code || Date.now() - (v.at || 0) > MAX_AGE) return null
    return v
  } catch (e) { return null }
}

// alreadyThere: the client is on Settings → Integrations now, so no bounce is needed.
export function saveShopifyLink(code, shop, alreadyThere = false) {
  if (!/^[a-f0-9]{32}$/.test(String(code || ''))) return
  try {
    localStorage.setItem(KEY, JSON.stringify({ code: String(code), shop: String(shop || ''), at: Date.now(), bounced: !!alreadyThere }))
  } catch (e) { /* private window: the query string still works on this visit */ }
}

export function pendingShopifyLink() {
  const v = read()
  return v ? { code: v.code, shop: v.shop } : null
}

// True once per saved link: the router uses it to bring a freshly signed-in client
// to Settings → Integrations without trapping them there.
export function takeShopifyBounce() {
  const v = read()
  if (!v || v.bounced) return false
  try { localStorage.setItem(KEY, JSON.stringify({ ...v, bounced: true })) } catch (e) { return false }
  return true
}

export function clearShopifyLink() {
  try { localStorage.removeItem(KEY) } catch (e) { /* nothing to clear */ }
}
